import { resizeObservers as r } from "./ghl-ui.es1655.js";
var t = function() {
  return r.some(function(e) {
    return e.skippedTargets.length > 0;
  });
};
export {
  t as hasSkippedObservations
};
